import { CommonModule, registerLocaleData } from "@angular/common";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import localeFrCa from "@angular/common/locales/fr-CA";
import {
  CUSTOM_ELEMENTS_SCHEMA,
  ErrorHandler,
  NgModule,
  inject,
} from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { LayoutModule } from "app/bundles/layouts/layout.module";
import { CustomErrorHandler } from "app/core/custom-error-handler";
import { ErrorMessageService } from "app/core/error-message.service";
import { StorageService } from "app/shared/services/storage.service";
import { NgxSpinnerModule } from "ngx-spinner";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app.routes";
import { UserProfileService } from "./bundles/authorize/shared/user-profile.service";
import { RequestsModule } from "./bundles/requests/requests.module";
import { UserProfileComponent } from "./bundles/user-profile/user-profile.component";
import { CoreModule } from "./core/core.module";
import { PreviousPageService } from "./core/previous-page.service";
import { HeaderComponent } from "./layouts/header/header.component";
import { SharedModule } from "./shared/shared.module";

registerLocaleData(localeFrCa);

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [AppComponent, HeaderComponent, UserProfileComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    CoreModule.forRoot(),
    SharedModule.forRoot(),
    LayoutModule,
    RequestsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgxSpinnerModule,
    CommonModule,
  ],
  providers: [
    StorageService,
    ErrorMessageService,
    { provide: ErrorHandler, useClass: CustomErrorHandler },
    UserProfileService,
    PreviousPageService,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
